/*
 * @Author: changcheng
 * @LastEditTime: 2022-08-18 14:28:05
 */
import { UserProps, InitUserInfo } from "@root/actions/index";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: UserProps = InitUserInfo;

export const userSlice = createSlice({
  name: "userInfo",
  initialState,
  reducers: {
    setUserInfo: (state, action: PayloadAction<UserProps>) => {
      state = action.payload;
      return state;
    },
  },
});

// Action creators are generated for each case reducer function
const { actions, reducer } = userSlice;
export const { setUserInfo } = actions;
export default reducer;
